"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    StatusSolid: function() {
        return StatusSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const StatusSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("rect", {
            x: "18.2422",
            y: "4",
            width: "2.2924",
            height: "6",
            rx: "1.1462",
            transform: "rotate(45 18.2422 4)",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("rect", {
            x: "4",
            y: "5.62109",
            width: "2.2924",
            height: "6",
            rx: "1.1462",
            transform: "rotate(-45 4 5.62109)",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("rect", {
            x: "11",
            y: "2",
            width: "2.2924",
            height: "6",
            rx: "1.1462",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("rect", {
            x: "2",
            y: "13.2925",
            width: "2.2924",
            height: "6",
            rx: "1.1462",
            transform: "rotate(-90 2 13.2925)",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("rect", {
            x: "16",
            y: "13.2925",
            width: "2.2924",
            height: "6",
            rx: "1.1462",
            transform: "rotate(-90 16 13.2925)",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("rect", {
            width: "2.2924",
            height: "6",
            rx: "1.1462",
            transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 18.2422 19.8638)",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("rect", {
            width: "2.2924",
            height: "6",
            rx: "1.1462",
            transform: "matrix(0.707107 0.707107 0.707107 -0.707107 4 18.2427)",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("rect", {
            width: "2.2924",
            height: "6",
            rx: "1.1462",
            transform: "matrix(1 0 0 -1 11 21.8638)",
            fill: "currentColor"
        })
    ]
}), "StatusSolid");
const _default = StatusSolid;
